const state = {
    upcoming: {
        title: '',
        filters: {},
        events: [],
        page: 1,
        type: '',
        total: '',
        loading: false,
        canLoadMore: false,
    },
    past: {
        title: '',
        filters: {},
        events: [],
        page: 1,
        type: '',
        total: '',
        loading: false,
        canLoadMore: false,
    },
    fallbackImage: '',
    api: '',
    apiKey: '',
}

export default state;